const utils = {
    colors: ["#4cd", "#46b", "#1da", "#58d", "#58d", "#28f"]
}

export default utils